"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const ecommerce_1 = require("../../api/ecommerce");
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
const NavigationAliases = __importStar(require("../constants/NavigationAliases"));
const MAIN_NAVIGATION_DEPTH = 2;
class ShopwareNavigation {
    api = new ecommerce_1.NavigationApi(configuration_1.default);
    loading = false;
    initialized = false;
    internalMainNavigationCategories = [];
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            loading: mobx_1.observable,
            initialized: mobx_1.observable,
            internalMainNavigationCategories: mobx_1.observable,
            isLoading: mobx_1.computed,
            isInitialized: mobx_1.computed,
            mainNavigationCategories: mobx_1.computed,
        });
    }
    initialize() {
        if (this.initialized || this.loading) {
            return;
        }
        this.loadMainNavigationCategories();
    }
    reset() {
        this.initialized = false;
        this.internalMainNavigationCategories = [];
    }
    get isLoading() {
        return this.loading;
    }
    get isInitialized() {
        return this.initialized;
    }
    get mainNavigationCategories() {
        return this.internalMainNavigationCategories.filter((category) => category.type !== ecommerce_1.CategoryTypeEnum.Folder);
    }
    loadMainNavigationCategories() {
        this.loading = true;
        return this.api
            .readNavigation({
            requestActiveId: NavigationAliases.MAIN_NAVIGATION,
            requestRootId: NavigationAliases.MAIN_NAVIGATION,
            depth: MAIN_NAVIGATION_DEPTH,
            buildTree: true,
        })
            .then((0, mobx_1.action)((categories) => {
            this.internalMainNavigationCategories = categories ?? [];
            return categories;
        }))
            .finally((0, mobx_1.action)(() => {
            this.loading = false;
            this.initialized = true;
        }));
    }
}
exports.default = new ShopwareNavigation();
